// Custom css import
import './style.css';

// Bootstrap import
import Form from 'react-bootstrap/Form';

// React import
import React, { useState } from 'react';

// Widgets import
import ModalBtn from '../../molecules/modalButton/view';
import { setSubContableAcounts } from '../../../usecases/contable-acounts-usecase';
import { AiOutlinePlusCircle } from 'react-icons/ai';
import ButtonPrimary from '../../atoms/ButtonPrimary/view';
import { dispatchCustomEvent } from '../../../utils/dispatch';
import { Switch } from '@mui/material';
import { lang } from '../../../utils/langs';
import { Col, Row } from 'react-bootstrap';
import AccountSearchDropdown from '../../molecules/AccountSearchDropdown/view';
import Tooltip from '@mui/material/Tooltip';
import { HelpCircle } from 'lucide-react';

function Cuentas({ profile, id = null }) {
    const [selectedAccount, setSelectedAccount] = useState(null);
    const [formData, SetFormData] = useState({
        'accounts_id': null,
        "code": '',
        "description": '',
        "need_third": false,
        "is_tax": false
    });

    const [codeError, setCodeError] = useState(false);
    const [descriptionError, setDescriptionError] = useState(false);

    function handleChange(event) {
        const { name, value } = event.target;
        if (name === 'code') {
            const digitsOnly = value.replace(/\D/g, '');
            SetFormData((prev) => ({
                ...prev,
                [name]: digitsOnly,
            }));
            if (digitsOnly.length > 2) {
                setCodeError(true);
            } else {
                setCodeError(false);
            }
        } else if (name === "need_third" || name === "is_tax") {
            SetFormData((prev) => ({
                ...prev,
                [name]: event.target.checked,
            }));
        } else {
            SetFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
            if (name === 'description') {
                setDescriptionError(value.trim() === '');
            }
        }
    }

    function handleAccountSelect(account) {
        setSelectedAccount(account);
        SetFormData((prev) => ({
            ...prev,
            'accounts_id': account?.id,
            'need_third': account?.requiere_tercero || false
        }));
    }

    function addAccount() {
        let hasError = false;

        if (formData.code.length > 2) {
            setCodeError(true);
            hasError = true;
        }

        if (!formData.description || formData.description.trim() === '') {
            setDescriptionError(true);
            hasError = true;
        }

        if (hasError) {
            dispatchCustomEvent('loading-btn', {});
        } else {
            if (!selectedAccount?.id) {
                dispatchCustomEvent("popup", { message: "Debes seleccionar una cuenta primero", type: "error" });
                dispatchCustomEvent('loading-btn', {});
                return;
            }
            setSubContableAcounts("", "", selectedAccount.id, formData).then((res) => {
                dispatchCustomEvent('loading-btn', {});
                // Limpiar el formulario
                SetFormData({
                    'accounts_id': selectedAccount.id,
                    "code": '',
                    "description": '',
                    "need_third": selectedAccount?.requiere_tercero || false,
                    "is_tax": false
                });

                dispatchCustomEvent('modal-close-account-create', {});
                dispatchCustomEvent('update-subaccounts', {});
            }).catch((err) => {
                dispatchCustomEvent("popup", { message: lang('es', err.response?.data?.message || 'Error al crear la cuenta'), type: "error" });
                dispatchCustomEvent('loading-btn', {});
            });
        }
    }

    return (
        <ModalBtn
            id={id ? "account-create-" + id : "account-create"}
            title="Crear Cuenta Auxiliar"
            icon={<AiOutlinePlusCircle />}
            style={{ width: '65vw', maxWidth: '95vw' }}
        >
            <div className="new-cuentas-container">
                {/* Columna Izquierda (30% - Sidebar) */}
                <div className="new-cuentas-sidebar">
                    <h5 className="new-cuentas-section-title">Cuenta Auxiliar</h5>
                    <p className="new-cuentas-section-desc">
                        Crea una subcuenta de nivel auxiliar seleccionando primero una cuenta contable padre.
                        Indica el sufijo identificador (máximo 2 dígitos), asigna una descripción y define sus propiedades operativas.
                    </p>
                </div>

                {/* Columna Derecha (70% - Formulario) */}
                <div className="new-cuentas-form-right">
                    <Form action="javascript:void(0);" style={{ width: '100%', outline: 'none', display: 'block' }}>

                        {/* Cuenta Padre */}
                        <Form.Group className="cuentas-field-group mb-3">
                            <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '6px' }}>
                                <label className="cuentas-label">Cuenta Padre</label>
                                <Tooltip title="Busca y selecciona la cuenta contable de nivel superior a la cual pertenecerá este auxiliar." arrow placement="top">
                                    <span style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', color: 'var(--color-gray-60, #888)' }}>
                                        <HelpCircle size={14} />
                                    </span>
                                </Tooltip>
                            </div>
                            <AccountSearchDropdown
                                onSelected={handleAccountSelect}
                                selected={selectedAccount}
                            />
                        </Form.Group>

                        {/* Preview de la cuenta */}
                        {selectedAccount && (
                            <div className="cuentas-preview-card mb-3">
                                <span className="cuentas-preview-label">Vista previa</span>
                                <span className="cuentas-preview-code">
                                    {selectedAccount?.account}{formData?.code || '??'}
                                </span>
                                <span className="cuentas-preview-name">
                                    {formData?.description || 'Nombre de la subcuenta'}
                                </span>
                            </div>
                        )}

                        <hr className="new-cuentas-separator" />

                        {/* Sufijo y Nombre en fila */}
                        <div className="new-cuentas-fields-row" style={{ display: 'flex', gap: '20px', width: '100%', marginBottom: '16px' }}>
                            <Form.Group style={{ flex: 1 }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '6px' }}>
                                    <label className="cuentas-label">Sufijo</label>
                                    <Tooltip title="Identificador secundario numérico (ej. 01, 02). Máximo 2 dígitos." arrow placement="top">
                                        <span style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', color: 'var(--color-gray-60, #888)' }}>
                                            <HelpCircle size={14} />
                                        </span>
                                    </Tooltip>
                                </div>
                                <Form.Control
                                    className='cuentas-input'
                                    type="text"
                                    placeholder="Ej: 01"
                                    onChange={handleChange}
                                    name='code'
                                    value={formData.code}
                                    isInvalid={codeError}
                                />
                                {codeError && (
                                    <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                                        Máximo 2 dígitos.
                                    </Form.Control.Feedback>
                                )}
                            </Form.Group>

                            <Form.Group style={{ flex: 2 }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '6px' }}>
                                    <label className="cuentas-label">Nombre</label>
                                    <Tooltip title="Nombre o descripción para identificar esta cuenta auxiliar." arrow placement="top">
                                        <span style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', color: 'var(--color-gray-60, #888)' }}>
                                            <HelpCircle size={14} />
                                        </span>
                                    </Tooltip>
                                </div>
                                <Form.Control
                                    className='cuentas-input'
                                    type="text"
                                    placeholder="Descripción de la cuenta"
                                    onChange={handleChange}
                                    name='description'
                                    value={formData.description}
                                    isInvalid={descriptionError}
                                />
                                {descriptionError && (
                                    <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                                        La descripción es obligatoria.
                                    </Form.Control.Feedback>
                                )}
                            </Form.Group>
                        </div>

                        <hr className="new-cuentas-separator" />

                        {/* Toggles inline */}
                        <div className="cuentas-toggles-row mb-4">
                            <div className="cuentas-toggle-item">
                                <Switch
                                    name='need_third'
                                    size="small"
                                    onChange={handleChange}
                                    checked={formData.need_third}
                                    disabled={selectedAccount?.requiere_tercero}
                                />
                                <span className="cuentas-toggle-label">Requiere Tercero</span>
                            </div>
                            <div className="cuentas-toggle-item">
                                <Switch
                                    name='is_tax'
                                    size="small"
                                    onChange={handleChange}
                                    checked={formData.is_tax}
                                />
                                <span className="cuentas-toggle-label">Es Impuesto</span>
                            </div>
                        </div>

                    </Form>
                    <ButtonPrimary
                        id="add-account"
                        onClick={addAccount}
                        showLoading={true}
                        title="Guardar cuenta auxiliar"
                        disabled={codeError || descriptionError || !selectedAccount}
                    />
                </div>
            </div>
        </ModalBtn>
    );
}

export default Cuentas;
